import { createFileRoute } from '@tanstack/react-router'
import JobAdPage from '../../../components/pages/JobAdPage'
import { parseJobAdSearch } from '../../../utils/buildJobApplyRoute'

export const Route = createFileRoute('/$slug/$uuid/')({
  validateSearch: parseJobAdSearch,
  component: JobAdRender,
})

function JobAdRender() {
  const { slug, uuid } = Route.useParams()
  const { referer } = Route.useSearch()

  return <JobAdPage slug={slug} uuid={uuid} referer={referer} />
}
